import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { useAuth } from "../../lib/auth";
import { api, apiError } from "../../lib/api";

const Forgot = ({ onBack }) => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); setSent(true); } catch (err) { toast.error(apiError(err)); }
  };
  if (sent) return <p data-testid="forgot-sent" className="rounded-2xl bg-[var(--lime)]/30 p-4 text-sm">Si hay una cuenta con ese email, te mandamos un link para crear una contraseña nueva. <button type="button" onClick={onBack} className="font-bold underline">Volver</button></p>;
  return (
    <form onSubmit={send} className="space-y-3">
      <Input data-testid="forgot-email" type="email" required placeholder="Tu email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl" />
      <button data-testid="forgot-submit" className="h-12 w-full rounded-xl bg-[var(--forest)] font-bold text-white">Mandarme el link</button>
      <button type="button" onClick={onBack} className="w-full text-sm font-semibold text-[var(--forest)]">Volver a ingresar</button>
    </form>
  );
};

export const AuthForm = ({ onDone, intro }) => {
  const { login, register } = useAuth();
  const [mode, setMode] = useState("register");
  const [f, setF] = useState({ name: "", dni: "", phone: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const u = mode === "login" ? await login(f.email, f.password) : await register(f);
      onDone?.(u);
    } catch (err) { setError(apiError(err)); } finally { setBusy(false); }
  };
  if (mode === "forgot") return <Forgot onBack={() => setMode("login")} />;
  return (
    <form onSubmit={submit} data-testid="auth-form" className="space-y-3">
      {intro && <p className="text-sm text-[var(--muted-ink)]">{intro}</p>}
      <div className="grid grid-cols-2 gap-1 rounded-full bg-[var(--paper)] p-1 text-sm font-bold">
        {[["register", "Crear cuenta"], ["login", "Ya tengo cuenta"]].map(([k, l]) => (
          <button key={k} type="button" onClick={() => setMode(k)} data-testid={`auth-tab-${k}`} className={`rounded-full py-2 transition-colors ${mode === k ? "bg-[var(--ink)] text-white" : ""}`}>{l}</button>
        ))}
      </div>
      {mode === "register" && (
        <>
          <Input data-testid="auth-name" required minLength={2} placeholder="Nombre y apellido" value={f.name} onChange={set("name")} className="h-12 rounded-xl" />
          <div className="grid grid-cols-2 gap-3">
            <Input data-testid="auth-dni" required inputMode="numeric" pattern="\d{6,10}" title="Solo números, 6 a 10 dígitos" placeholder="DNI" value={f.dni} onChange={set("dni")} className="h-12 rounded-xl" />
            <Input data-testid="auth-phone" placeholder="Celular (opcional)" value={f.phone} onChange={set("phone")} className="h-12 rounded-xl" />
          </div>
        </>
      )}
      <Input data-testid="auth-email" type="email" required placeholder="Email" value={f.email} onChange={set("email")} className="h-12 rounded-xl" />
      <Input data-testid="auth-password" type="password" required minLength={mode === "register" ? 8 : 1} placeholder={mode === "register" ? "Contraseña (mínimo 8)" : "Contraseña"} value={f.password} onChange={set("password")} className="h-12 rounded-xl" />
      {error && <p data-testid="auth-error" className="text-sm font-medium text-red-700">{error}</p>}
      <button data-testid="auth-submit" disabled={busy} className="flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-[var(--forest)] font-bold text-white hover:bg-[var(--forest-2)]">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} {mode === "login" ? "Ingresar" : "Crear cuenta y seguir"}
      </button>
      {mode === "login" && <button type="button" onClick={() => setMode("forgot")} data-testid="auth-forgot" className="w-full text-sm font-semibold text-[var(--forest)]">Olvidé mi contraseña</button>}
    </form>
  );
};
